import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=71e2d7d5&scoped=true&lang=pug&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2d7d5",
  null
  
)

export default component.exports